var e = {
	accountDeletionBlocker: {
		workspace_owner: "You own a workspace. Transfer or close it (contact support) before deleting your account.",
		admin_account: "This account holds admin access. Another admin must remove it first.",
		active_bookings: "You have upcoming or in-progress bookings, payment holds, or pending booking changes.",
		unsettled_creator_balance: "Your creator balance isn't settled yet — your pending payout must be paid out or cancelled first.",
		service_unavailable: "We couldn't complete all the checks right now, so nothing was changed. Please try again in a few minutes."
	},
	areaType: {
		touristic: "Touristic",
		city: "City",
		coastal: "Coastal",
		rural: "Rural",
		resort: "Resort",
		island: "Island",
		mountain: "Mountain",
		desert: "Desert",
		suburban: "Suburban"
	},
	attractionCategory: {
		restaurants: "Restaurants",
		cafes: "Cafés",
		supermarkets: "Supermarkets",
		pharmacies: "Pharmacies",
		hospitals: "Hospitals",
		banks: "Banks & ATMs",
		gas_stations: "Gas stations",
		airports: "Airports",
		shopping_malls: "Shopping malls",
		tourist_attractions: "Tourist attractions",
		gyms: "Gyms",
		schools: "Schools"
	},
	bookingStatus: {
		pending: "Pending",
		confirmed: "Confirmed",
		checked_in: "Checked In",
		completed: "Completed",
		rejected: "Rejected",
		cancelled: "Cancelled",
		no_show: "No-show"
	},
	callbackStatus: {
		pending: "Pending",
		contacted: "Called",
		cancelled: "Cancelled"
	},
	callbackTimeSlot: {
		morning: "Morning (9am – 12pm)",
		afternoon: "Afternoon (12pm – 4pm)",
		evening: "Evening (4pm – 8pm)"
	},
	cancellationPolicyType: {
		firm: "Firm",
		moderate: "Moderate",
		flexible: "Flexible",
		strict: "Strict",
		standard: "Standard",
		slot_24h: "24-hour"
	},
	channelPartnerDeliveryStatus: {
		pending: "Queued",
		retrying: "Retrying",
		delivering: "Sending",
		delivered: "Delivered",
		failed: "Failed",
		redacted: "Erased"
	},
	channelPartnerKeyScope: {
		partner_token_issue: "Token exchange",
		partner_mcp_read: "API docs (MCP)",
		catalog_read: "Read catalogue",
		catalog_write: "Write catalogue",
		media_write: "Manage photos",
		calendar_read: "Read calendar",
		calendar_write: "Write calendar",
		pricing_write: "Set pricing",
		rules_write: "Apply quick-action rules",
		rates_read: "Read supplied rates",
		rates_write: "Supply nightly rates",
		bookings_read: "Read bookings",
		guests_read: "Read guest names",
		bookings_manage: "Manage bookings",
		reviews_read: "Read reviews",
		reviews_reply: "Reply to reviews",
		webhooks_manage: "Manage webhooks",
		finance_read: "Read earnings and payouts"
	},
	channelPartnerKeyScopeDescription: {
		partner_token_issue: "Exchange the key for a short-lived token. Included on every key — what that token may do is decided by the other scopes.",
		partner_mcp_read: "Read the published API specification and guides over MCP. Read-only, and reaches no workspace data of any kind.",
		catalog_read: "Read properties, units, listings and the amenity and house-rule catalogues.",
		catalog_write: "Create, replace and edit properties and units.",
		media_write: "Upload, arrange and remove property photos.",
		calendar_read: "Read availability and the calendar blocks this key pushed.",
		calendar_write: "Push and release calendar blocks.",
		pricing_write: "Set a unit's base rate, fees and currency.",
		rules_write: "Apply and remove the quick-action booking and pricing rules on a listing.",
		rates_read: "Read the nightly rates supplied through the partner rate calendar.",
		rates_write: "Supply nightly rates for a date range. Puts the listing in partner pricing mode, which switches off its own pricing rules.",
		bookings_read: "Read bookings — dates, status and amounts. The guest's name needs Read guest names as well.",
		guests_read: "Add the guest's display name — first name and last initial — to the bookings this key reads. Nothing else about the guest.",
		bookings_manage: "Confirm a booking request, cancel a booking, answer a modification request.",
		reviews_read: "Read the reviews guests left on the workspace's listings.",
		reviews_reply: "Post a public reply to a review, as the workspace.",
		webhooks_manage: "Register and rotate the endpoint deliveries are sent to, and read the delivery log.",
		finance_read: "Read the workspace's earnings and payout history."
	},
	channelPartnerWebhookEndpointStatus: {
		pending_verification: "Awaiting challenge",
		active: "Active",
		suspended: "Suspended"
	},
	workspaceDeveloperState: {
		none: "Not requested",
		requested: "Requested",
		accepted: "Accepted",
		active: "Active",
		declined: "Declined",
		revoked: "Revoked"
	},
	workspaceDeveloperEnvironment: {
		live: "Live",
		sandbox: "Sandbox"
	},
	couponDiscountType: {
		PERCENTAGE: "Percentage",
		FIXED: "Fixed amount"
	},
	couponFundingSource: {
		PLATFORM_BALANCE: "Platform balance",
		PLATFORM_REVENUE: "Platform revenue",
		BANK_TRANSFER: "Bank transfer"
	},
	couponStatus: {
		ACTIVE: "Active",
		PAUSED: "Paused",
		EXPIRED: "Expired"
	},
	currency: {
		USD: "US Dollar",
		EUR: "Euro",
		GBP: "British Pound",
		EGP: "Egyptian Pound",
		SAR: "Saudi Riyal",
		AED: "UAE Dirham"
	},
	guideCategory: {
		food_coffee: "Food & Coffee",
		hidden_gems: "Hidden Gems",
		family_activities: "Family Activities",
		nightlife: "Nightlife",
		art_culture: "Art & Culture",
		shopping: "Shopping",
		nature_outdoors: "Nature & Outdoors",
		getting_around: "Getting Around"
	},
	guideFlagSeverity: {
		low: "Low",
		medium: "Medium",
		high: "High"
	},
	guideFlagType: {
		spam: "Spam",
		promotional_content: "Promotional content",
		inappropriate_language: "Inappropriate language",
		low_quality_content: "Low-quality content",
		off_topic: "Off-topic",
		fake_place: "Unverifiable place",
		missing_context: "Missing details",
		policy_violation: "Policy violation"
	},
	helpCategory: {
		"getting-started": "Getting started",
		bookings: "Bookings",
		payments: "Payments",
		payouts: "Payouts",
		hosting: "Hosting",
		pricing: "Pricing & rules",
		account: "Account & security",
		reviews: "Reviews",
		"ai-assistant": "AI assistant",
		"trust-safety": "Trust & safety"
	},
	icalFeedStatus: {
		active: "Active",
		degraded: "Degraded",
		suspended: "Suspended"
	},
	pricelabsSyncState: {
		pushing: "Sending to PriceLabs",
		live: "Live",
		error: "Sync failed"
	},
	icalSource: {
		airbnb: "Airbnb",
		vrbo: "VRBO",
		booking_com: "Booking.com",
		custom: "Custom"
	},
	imageCategory: {
		cover: "Cover photo",
		general: "Main photos",
		highlights: "Highlights",
		living_room: "Living room",
		dining_area: "Dining area",
		kitchen: "Kitchen",
		bedroom: "Bedrooms",
		bathroom: "Bathrooms",
		exterior: "Exterior",
		backyard: "Backyard",
		pool: "Pool",
		patio: "Patio",
		balcony: "Balcony",
		neighbourhood: "Neighbourhood"
	},
	imageCategorySpace: {
		bedroom: "Bedroom {{index}}",
		bathroom: "Bathroom {{index}}"
	},
	invitationStatus: {
		pending: "Pending",
		accepted: "Accepted",
		declined: "Declined",
		expired: "Expired",
		cancelled: "Cancelled"
	},
	listingReviewStatus: {
		new: "New",
		hidden_gem: "Hidden Gem",
		building_reputation: "Building Reputation",
		popular_choice: "Popular Choice",
		guest_favorite: "Guest Favorite"
	},
	moderationRecommendedAction: {
		approve: "Approve",
		reject: "Reject",
		request_changes: "Request changes"
	},
	modificationStatus: {
		awaiting_approval: "Awaiting approval",
		awaiting_payment: "Awaiting payment",
		applied: "Applied",
		declined: "Declined",
		cancelled: "Cancelled",
		expired: "Expired"
	},
	modificationMode: {
		RESCHEDULE: "Reschedule",
		EXTEND: "Extend",
		UNIT_CHANGE: "Unit change"
	},
	modificationDirection: {
		CHARGE: "Charge",
		REFUND: "Refund",
		NONE: "No change"
	},
	notificationCategory: {
		booking: "Bookings",
		payments: "Payments",
		reviews: "Reviews",
		chat: "Messages",
		workspace: "Workspace",
		security: "Account & security",
		support: "Support",
		system: "System",
		trip_planning: "Trip planning"
	},
	notificationChannel: {
		in_app: "In-app",
		email: "Email",
		sms: "SMS",
		push: "Push"
	},
	partnerChannel: {
		INSTAGRAM: "Instagram",
		TIKTOK: "TikTok",
		YOUTUBE: "YouTube",
		X: "X (Twitter)",
		FACEBOOK: "Facebook",
		SNAPCHAT: "Snapchat",
		WHATSAPP: "WhatsApp",
		OTHER: "Other"
	},
	penaltyMethod: {
		CHECK_IN: "Collected from booking earnings",
		BALANCE: "Paid from balance",
		CARD: "Paid by card",
		ADMIN: "Adjusted by support"
	},
	penaltyStatus: {
		OUTSTANDING: "Outstanding",
		PARTIALLY_SETTLED: "Partially paid",
		SETTLED: "Settled",
		WRITTEN_OFF: "Written off"
	},
	guestDocumentRetention: {
		checkout: "Until checkout",
		checkout_7d: "7 days after checkout",
		checkout_30d: "30 days after checkout"
	},
	guestDocumentRetentionHint: {
		checkout: "Deleted once your stay is over.",
		checkout_7d: "Gives your host a week after you leave.",
		checkout_30d: "The longest we'll hold it."
	},
	permissionSlug: {
		"*": "Full Access",
		properties: {
			create: "Create Property",
			list: "List Properties",
			view: "View Property",
			update: "Edit Property",
			delete: "Delete Property",
			publish: "Publish Property"
		},
		experiences: {
			create: "Create Experience",
			list: "List Experiences",
			view: "View Experience",
			update: "Edit Experience",
			delete: "Delete Experience",
			publish: "Publish Experience"
		},
		services: {
			create: "Create Service",
			list: "List Services",
			view: "View Service",
			update: "Edit Service",
			delete: "Delete Service",
			publish: "Publish Service"
		},
		bookings: {
			view: "View Bookings",
			create: "Create Booking",
			approve: "Approve Booking",
			reject: "Reject Booking",
			cancel: "Cancel Booking"
		},
		guest_documents: { view: "View Guest ID Documents" },
		reservations: {
			view: "View Reservations",
			create: "Create Reservation",
			update: "Update Reservation",
			cancel: "Cancel Reservation"
		},
		finance: {
			view_payouts: "View Payouts",
			request_payout: "Request Payout",
			add_payment_method: "Add Payment Method",
			view_transactions: "View Transactions",
			view_billing: "View Billing Details",
			manage_billing: "Manage Billing Details",
			settle_debt: "Settle Outstanding Debt"
		},
		workspace: {
			view_members: "View Members",
			invite_members: "Invite Members",
			manage_members: "Remove Members",
			view_roles: "View Roles",
			manage_roles: "Manage Roles",
			assign_permissions: "Assign Member Permissions",
			view_invitations: "View Invitations",
			settings: "Workspace Settings"
		},
		verification: {
			view: "View Verification",
			submit: "Submit Verification"
		},
		pbac: {
			assign_users: "Assign Users to Properties",
			manage_groups: "Manage Property Groups",
			view_groups: "View Property Groups"
		},
		chat: {
			read: "Read Conversations",
			write: "Send Messages"
		},
		automated_messages: {
			view: "View Automated Messages",
			manage: "Manage Automated Messages"
		},
		pricing: {
			view: "View Pricing Rules",
			manage: "Manage Pricing Rules"
		},
		booking_rules: {
			view: "View Booking Rules",
			manage: "Manage Booking Rules"
		},
		calendar: {
			view: "View Calendar",
			manage: "Manage Calendar"
		},
		coupons: {
			view: "View Coupons",
			manage: "Manage Coupons"
		},
		travel_guides: {
			view: "View Travel Guides",
			manage: "Manage Travel Guides"
		},
		developer: {
			view: "View Developer Access",
			manage: "Manage Developer Access"
		},
		front_desk: {
			check_in: "Check Guests In",
			check_out: "Check Guests Out",
			no_show: "Mark No-shows"
		},
		rooms: { assign: "Assign Rooms" },
		housekeeping: {
			view: "View Room Status",
			update: "Update Room Status",
			inspect: "Inspect Rooms",
			assign: "Assign Housekeeping"
		},
		reports: { view: "View Reports" }
	},
	propertyAmenity: {
		wifi: "Wifi",
		tv: "TV",
		kitchen: "Kitchen",
		dedicated_workspace: "Dedicated workspace",
		ac: "A/C",
		heating: "Heating",
		pool: "Pool",
		shared_pool: "Shared pool",
		hot_tub: "Hot tub",
		gym: "Gym",
		washer: "Washer",
		dryer: "Dryer",
		on_site_parking: "On-site parking",
		street_parking: "Street parking",
		safe: "Safe",
		lockbox: "Lockbox",
		self_check_in: "Self check-in",
		luggage_drop_off: "Luggage drop-off",
		long_term_stays: "Long-term stays",
		beach_view: "Beach view",
		pool_view: "Pool view",
		city_view: "City view",
		sea_view: "Sea view",
		lagoon_view: "Lagoon view",
		garden_view: "Garden view",
		nile_view: "Nile view",
		lake_view: "Lake view",
		beach_access: "Beach access",
		beach: "Beach",
		lake: "Lake",
		private_balcony: "Private balcony",
		outdoor_furniture: "Outdoor furniture",
		shared_backyard: "Shared backyard",
		private_backyard: "Private backyard",
		outdoor_dining: "Outdoor dining",
		bbq_grill: "BBQ Grill",
		fire_pit: "Fire pit",
		sun_loungers: "Sun loungers",
		heated_pool: "Heated pool",
		smoke_alarm: "Smoke alarm",
		carbon_monoxide_alarm: "Carbon monoxide alarm",
		fire_extinguisher: "Fire extinguisher",
		first_aid_kit: "First aid kit",
		corner_guards: "Corner guards",
		secure_locks: "Secure locks on doors and windows",
		balcony_railings: "Balcony or terrace railings",
		window_guards: "Window guards",
		exterior_security_cameras: "Exterior security cameras",
		pool_safety_barrier: "Pool or hot tub safety barrier",
		stair_gates: "Stair gates",
		outdoor_security_lighting: "Outdoor security lighting",
		gas_leak_detector: "Gas leak detector",
		fire_blanket: "Fire blanket",
		emergency_lighting: "Emergency lighting",
		child_crib: "Child crib",
		high_chair: "High chair",
		baby_bath: "Baby bath",
		childrens_dinnerware: "Children's dinnerware",
		hair_dryer: "Hair Dryer",
		shampoo: "Shampoo",
		cleaning_products: "Cleaning Products",
		body_soap: "Body soap",
		shower_gel: "Shower gel",
		hot_water: "Hot water",
		bathtub: "Bathtub",
		jacuzzi: "Jacuzzi",
		bidet: "Bidet",
		towels: "Towels",
		hangers: "Hangers",
		bed_linens: "Bed linens",
		extra_bedding: "Extra bedding",
		darkening_shades: "Darkening shades",
		iron: "Iron",
		drying_rack: "Drying rack",
		wardrobe: "Wardrobe",
		microwave: "Microwave",
		coffee_maker: "Coffee Maker",
		refrigerator: "Refrigerator",
		cooking_basics: "Cooking basics",
		silverware: "Silverware",
		freezer: "Freezer",
		induction_stove: "Induction stove",
		oven: "Oven",
		water_kettle: "Water kettle",
		toaster: "Toaster",
		baking_sheet: "Baking sheet",
		dining_table: "Dining table",
		blender: "Blender",
		netflix: "Netflix",
		bluetooth_sound: "Bluetooth sound",
		arcade_games: "Arcade games",
		books: "Books",
		movie_theater: "Movie theater",
		table_games: "Table Games",
		exercise_equipment: "Exercise equipment",
		piano: "Piano",
		wood_fireplace: "Wood fireplace",
		ceiling_fan: "Ceiling fan",
		electric_fireplace: "Electric fireplace",
		paid_housekeeping: "Paid housekeeping",
		restaurant: "Restaurant",
		bar: "Bar",
		room_service: "Room service",
		front_desk_24h: "24-hour front desk",
		elevator: "Elevator",
		concierge: "Concierge",
		laundry_service: "Laundry service",
		business_centre: "Business centre",
		meeting_rooms: "Meeting rooms",
		spa: "Spa",
		sauna: "Sauna",
		casino: "Casino",
		kids_club: "Kids club",
		airport_shuttle: "Airport shuttle",
		breakfast_available: "Breakfast available",
		ev_charging: "EV charging",
		wheelchair_accessible: "Wheelchair accessible",
		tour_desk: "Tour desk",
		garden: "Garden",
		rooftop: "Rooftop",
		terrace: "Terrace",
		cctv_common_areas: "CCTV in common areas",
		security_24h: "24-hour security",
		key_card_access: "Key card access",
		kitchenette: "Kitchenette",
		private_entrance: "Private entrance",
		minibar: "Minibar",
		bathrobe: "Bathrobe",
		slippers: "Slippers",
		soundproofing: "Soundproofing",
		telephone: "Telephone",
		interconnecting_rooms: "Interconnecting rooms",
		sofa_bed: "Sofa bed",
		mosquito_net: "Mosquito net"
	},
	propertyAmenityPitch: {
		wifi: "Stay connected for streaming, calls and work.",
		tv: "Settle in for a movie night after a day out.",
		kitchen: "A full kitchen, so you can cook whenever you like.",
		dedicated_workspace: "A proper spot to get work done, away from the bed.",
		ac: "Keep cool through the hottest afternoons.",
		heating: "Stay warm and cosy on chilly nights.",
		pool: "Take a dip whenever you feel like it.",
		shared_pool: "Cool off in the pool you share with other guests.",
		hot_tub: "Unwind in a hot tub at the end of the day.",
		gym: "Keep up your routine without leaving the building.",
		washer: "Do a load of laundry and pack lighter.",
		dryer: "Get your clothes dry and ready in no time.",
		on_site_parking: "Park right at the property, no circling the block.",
		street_parking: "Find parking on the street nearby.",
		safe: "Lock away your valuables while you're out.",
		lockbox: "Pick up your keys from a lockbox on arrival.",
		self_check_in: "Let yourself in on your own schedule.",
		luggage_drop_off: "Drop off your bags and go explore before or after your stay.",
		long_term_stays: "Staying a month or more? This place welcomes long stays.",
		beach_view: "Wake up to a view of the beach.",
		pool_view: "Look out over the pool from your stay.",
		city_view: "Take in the city skyline from your window.",
		sea_view: "Soak up the sea view from the comfort of your stay.",
		lagoon_view: "Enjoy calm lagoon views right from your stay.",
		garden_view: "Look out onto green garden views.",
		nile_view: "Watch the Nile drift by from your stay.",
		lake_view: "Relax with a view over the lake.",
		beach_access: "Head straight onto the beach.",
		beach: "Make the most of the beach, right by your stay.",
		lake: "Spend your days by the lake.",
		private_balcony: "Your own balcony for morning coffee or a sunset drink.",
		outdoor_furniture: "Make yourself comfortable outside.",
		shared_backyard: "Enjoy the fresh air in a backyard shared with other guests.",
		private_backyard: "A backyard that's all yours for the stay.",
		outdoor_dining: "Share a meal outdoors in the open air.",
		bbq_grill: "Fire up the grill for a barbecue.",
		fire_pit: "Gather around the fire pit after dark.",
		sun_loungers: "Stretch out on a lounger and soak up the sun.",
		heated_pool: "Swim in comfort, whatever the weather.",
		smoke_alarm: "Fitted with a smoke alarm for peace of mind.",
		carbon_monoxide_alarm: "Fitted with a carbon monoxide alarm for peace of mind.",
		fire_extinguisher: "A fire extinguisher is on hand, just in case.",
		first_aid_kit: "A first aid kit is on hand for small mishaps.",
		corner_guards: "Softened corners for little ones on the move.",
		secure_locks: "Doors and windows lock securely.",
		balcony_railings: "Railings on the balcony or terrace for peace of mind.",
		window_guards: "Window guards help keep little ones safe.",
		exterior_security_cameras: "Exterior cameras keep an eye on the outside of the property.",
		pool_safety_barrier: "A barrier around the pool or hot tub for peace of mind.",
		stair_gates: "Stair gates help keep little ones safe.",
		outdoor_security_lighting: "The outside is well lit after dark.",
		gas_leak_detector: "Fitted with a gas leak detector for peace of mind.",
		fire_blanket: "A fire blanket is on hand, just in case.",
		emergency_lighting: "Emergency lighting in case the power goes out.",
		child_crib: "A crib ready for the littlest guests.",
		high_chair: "A high chair so the little ones can join you at the table.",
		baby_bath: "A baby bath, so there's one less thing to pack.",
		childrens_dinnerware: "Kid-friendly plates and cups for little hands.",
		hair_dryer: "Leave the hair dryer at home.",
		shampoo: "Shampoo is provided, so you can pack lighter.",
		cleaning_products: "Cleaning products on hand for any spills.",
		body_soap: "Body soap is provided, so you can pack lighter.",
		shower_gel: "Shower gel is provided, so you can pack lighter.",
		hot_water: "Hot water for a proper shower.",
		bathtub: "Sink into a long, relaxing bath.",
		jacuzzi: "Relax in a jacuzzi after a long day.",
		bidet: "A bidet in the bathroom.",
		towels: "Fresh towels are provided.",
		hangers: "Hang up your clothes and unpack properly.",
		bed_linens: "The bed is made up and ready for you.",
		extra_bedding: "Extra bedding for when you need an extra layer.",
		darkening_shades: "Sleep in with room-darkening shades.",
		iron: "Look sharp with an iron on hand.",
		drying_rack: "A drying rack for hand washing and swimwear.",
		wardrobe: "Plenty of room to unpack and settle in.",
		microwave: "Heat up a quick snack or leftovers.",
		coffee_maker: "Start the day with a fresh cup of coffee.",
		refrigerator: "Keep your food and drinks cold.",
		cooking_basics: "Pots, pans, oil, salt and pepper, ready to cook with.",
		silverware: "Everything you need to set the table.",
		freezer: "Stock up and keep things frozen.",
		induction_stove: "Cook up a meal on the induction stove.",
		oven: "Bake or roast a proper home-cooked meal.",
		water_kettle: "Boil water for tea or coffee in minutes.",
		toaster: "Toast for a quick breakfast.",
		baking_sheet: "Bake something sweet or savoury.",
		dining_table: "Sit down together for a proper meal.",
		blender: "Whip up smoothies and juices.",
		netflix: "Stream your favourite shows on Netflix.",
		bluetooth_sound: "Play your own music through the Bluetooth speaker.",
		arcade_games: "Arcade games for some friendly competition.",
		books: "A shelf of books for slow afternoons.",
		movie_theater: "Your own movie theater for a proper film night.",
		table_games: "Board and table games for nights in.",
		exercise_equipment: "Work out without leaving your stay.",
		piano: "Sit down and play the piano.",
		wood_fireplace: "Curl up by a crackling wood fire.",
		ceiling_fan: "A ceiling fan keeps the air moving.",
		electric_fireplace: "Warm up by the fireplace at the flick of a switch.",
		paid_housekeeping: "Housekeeping is available during your stay, for an extra fee.",
		restaurant: "Eat in at the on-site restaurant.",
		bar: "Wind down with a drink at the bar.",
		room_service: "Order food and drinks straight to your room.",
		front_desk_24h: "Someone is at the front desk day and night.",
		elevator: "An elevator takes you and your luggage between floors.",
		concierge: "The concierge can book tables, tours and transfers for you.",
		laundry_service: "Hand in your laundry and get it back clean.",
		business_centre: "Print, scan and work from the business centre.",
		meeting_rooms: "Book a meeting room for work or a small event.",
		spa: "Unwind with a treatment at the spa.",
		sauna: "Warm up in the sauna after a long day.",
		casino: "Try your luck at the on-site casino.",
		kids_club: "Children have their own club with activities.",
		airport_shuttle: "A shuttle runs between the airport and the property.",
		breakfast_available: "Start the day with breakfast at the property.",
		ev_charging: "Charge your electric car on site.",
		wheelchair_accessible: "Step-free access for wheelchair users.",
		tour_desk: "Plan trips and excursions at the tour desk.",
		garden: "Stroll or relax in the garden.",
		rooftop: "Take in the view from the rooftop.",
		terrace: "Sit out on the terrace in the open air.",
		cctv_common_areas: "Common areas are covered by security cameras.",
		security_24h: "Security staff are on duty around the clock.",
		key_card_access: "Rooms and entrances open with a key card.",
		kitchenette: "A compact kitchen for simple meals.",
		private_entrance: "Come and go through your own entrance.",
		minibar: "Cold drinks and snacks are in the minibar.",
		bathrobe: "A soft bathrobe is waiting for you.",
		slippers: "Slippers are provided.",
		soundproofing: "Soundproofed walls keep the noise out.",
		telephone: "A phone in the room reaches the front desk and beyond.",
		interconnecting_rooms: "Connecting rooms keep a family or group together.",
		sofa_bed: "A sofa bed makes room for one more.",
		mosquito_net: "Sleep under a mosquito net."
	},
	propertyAmenityCategory: {
		amenities: "Amenities",
		features: "Features",
		safety: "Safety",
		essentials: "Essentials"
	},
	propertyType: {
		apartment: "Apartment",
		studio: "Studio",
		house: "House",
		townhouse: "Townhouse",
		villa: "Villa",
		duplex: "Duplex",
		mansion: "Mansion",
		penthouse: "Penthouse",
		chalet: "Chalet",
		bungalow: "Bungalow",
		cabin: "Cabin",
		cottage: "Cottage",
		hotel: "Hotel",
		boutique_hotel: "Boutique hotel",
		guesthouse: "Guesthouse"
	},
	rentalType: {
		full_house: "Full House",
		individual_listings: "Multiple Listings"
	},
	reviewCategory: {
		cleanliness: "Cleanliness",
		accuracy: "Accuracy",
		check_in: "Check-in",
		communication: "Communication",
		location: "Location",
		value: "Value",
		host: "Host"
	},
	reviewTag: {
		cleanliness_spotless_linens: "Spotless furniture & linens",
		cleanliness_free_of_clutter: "Free of clutter",
		cleanliness_squeaky_clean_bathroom: "Squeaky-clean bathroom",
		cleanliness_pristine_kitchen: "Pristine kitchen",
		cleanliness_dirty_or_dusty: "Dirty or dusty",
		cleanliness_noticeable_smell: "Noticeable smell",
		cleanliness_stains: "Stains",
		cleanliness_unclean_bathroom: "Unclean bathroom",
		cleanliness_messy_kitchen: "Messy kitchen",
		accuracy_looks_like_photos: "Looked like the photos",
		accuracy_matches_description: "Matched the description",
		accuracy_had_listed_amenities: "Had the listed amenities",
		accuracy_smaller_than_expected: "Smaller than expected",
		accuracy_missing_amenities: "Missing amenities",
		accuracy_needs_maintenance: "Needs maintenance",
		check_in_clear_instructions: "Clear instructions",
		check_in_easy_to_find: "Easy to find",
		check_in_easy_to_get_inside: "Easy to get inside",
		check_in_flexible: "Flexible check-in",
		check_in_hard_to_find: "Hard to find",
		check_in_unclear_instructions: "Unclear instructions",
		check_in_trouble_getting_in: "Trouble getting in",
		check_in_long_wait: "Long wait",
		communication_always_responsive: "Always responsive",
		communication_local_recommendations: "Local recommendations",
		communication_proactive: "Proactive",
		communication_helpful_instructions: "Helpful instructions",
		communication_slow_to_respond: "Slow to respond",
		communication_unhelpful: "Not helpful",
		communication_missing_house_info: "Missing house info",
		location_peaceful: "Peaceful",
		location_beautiful_surroundings: "Beautiful surroundings",
		location_private: "Private",
		location_great_restaurants: "Great restaurants",
		location_lots_to_do: "Lots to do",
		location_walkable: "Walkable",
		location_noisy: "Noisy",
		location_not_much_nearby: "Not much nearby",
		location_hard_to_get_around: "Hard to get around",
		host_welcoming: "Welcoming",
		host_above_and_beyond: "Went above and beyond",
		host_respected_privacy: "Respected my privacy",
		host_unwelcoming: "Unwelcoming",
		host_intrusive: "Intrusive"
	},
	reviewTopic: {
		cleanliness: "Cleanliness",
		comfort: "Comfort",
		space: "Space",
		amenities: "Amenities",
		noise: "Noise",
		location: "Location",
		arrival: "Arrival",
		hospitality: "Hospitality",
		value: "Value",
		accuracy: "Accuracy"
	},
	supportUserType: {
		guest: "Guests",
		host: "Hosts",
		both: "Guests & hosts"
	},
	ticketCategory: {
		booking: "Bookings",
		payment: "Payments",
		property: "Properties",
		account: "Account",
		technical: "Technical issue",
		other: "Other"
	},
	ticketStatus: {
		open: "Open",
		in_progress: "In progress",
		resolved: "Resolved",
		closed: "Closed"
	},
	travelGuideModerationStatus: {
		none: "Not submitted",
		pending: "AI review in progress",
		clean: "Auto-approved",
		flagged: "Needs review",
		resolved: "Approved",
		rejected: "Rejected",
		error: "Review needed"
	},
	travelGuideStatus: {
		draft: "Draft",
		pending_review: "In review",
		published: "Published",
		rejected: "Rejected",
		archived: "Archived"
	},
	withdrawalStatus: {
		REQUESTED: "Requested",
		PAID: "Paid",
		REJECTED: "Rejected",
		CANCELLED: "Cancelled"
	},
	withdrawalMethod: {
		BANK_TRANSFER: "Bank transfer",
		INSTAPAY: "InstaPay",
		WALLET: "Wallet"
	},
	ruleTemplateCategory: {
		stay_length: "Stay length",
		seasonal: "Seasonal",
		weekend: "Weekend",
		guest_count: "Guest count",
		lead_time: "Lead time",
		occupancy: "Occupancy",
		other: "Other"
	},
	poolRoomStatus: {
		active: "Active",
		out_of_order: "Out of order"
	},
	unitType: {
		whole_property: "Whole property",
		private_room: "Private room",
		room: "Room",
		suite: "Suite"
	},
	verificationStatus: {
		unverified: "Not started",
		pending: "Under review",
		verified: "Verified",
		rejected: "Rejected"
	},
	verificationDocReviewStatus: {
		pending: "Under review",
		approved: "Approved",
		rejected: "Rejected"
	},
	verificationDocumentType: {
		id_card_front: "National ID — front",
		id_card_back: "National ID — back",
		passport: "Passport",
		selfie: "Selfie",
		proof_of_address: "Proof of address",
		business_registration: "Business registration",
		certificate_of_incorporation: "Certificate of incorporation",
		tax_card: "Tax card",
		other: "Other"
	},
	verificationDocumentHint: {
		id_card_front: "JPG, PNG or PDF",
		id_card_back: "JPG, PNG or PDF",
		passport: "JPG, PNG or PDF",
		selfie: "A clear photo of your face",
		proof_of_address: "Utility bill or bank statement",
		business_registration: "JPG, PNG or PDF",
		certificate_of_incorporation: "JPG, PNG or PDF",
		tax_card: "JPG, PNG or PDF"
	},
	csatFeature: {
		booking_flow: "Booking",
		property_search: "Property search",
		host_calendar: "Calendar",
		host_listings: "Listings",
		messaging: "Messaging",
		review_submission: "Reviews",
		booking_cancellation: "Cancellation",
		booking_modification: "Booking changes",
		host_booking_review: "Booking requests",
		pricing_rules: "Pricing rules",
		support: "Support"
	},
	hostActionType: {
		PENALTY_DEBT: "Outstanding penalty",
		PAYOUT_METHOD_MISSING: "Payout blocked",
		PAYOUT_REJECTED: "Payout rejected",
		LISTING_SUSPENDED: "Listing suspended",
		VERIFICATION_REQUIRED: "Verification",
		CALENDAR_FEED_FAILING: "Calendar sync",
		DATE_CHANGE_REQUEST: "Date-change request",
		EXTENSION_REQUEST: "Extension request",
		UNREAD_MESSAGES: "Unread messages",
		MESSAGE_REQUEST: "Message request",
		REVIEW_UNANSWERED: "Review awaiting reply",
		BOOKING_REQUEST: "Booking request",
		PROPERTY_DRAFT: "Unfinished listing",
		INVITATION_PENDING: "Invitation sent",
		OFFER_AWAITING_PAYMENT: "Offer sent",
		ROOM_OUT_OF_ORDER_WITH_BOOKINGS: "Room out of order",
		ARRIVAL_ROOM_NOT_READY: "Room not ready"
	},
	availabilityGridDayStatus: {
		open: "Open",
		partial: "Partly closed",
		closed: "Closed"
	},
	blockReasonCategory: {
		maintenance: "Maintenance",
		personal_use: "Personal use",
		renovation: "Renovation",
		cleaning: "Cleaning",
		other: "Other"
	},
	rateGridPriceSource: {
		override: "Your price",
		rules: "Set by pricing rules",
		base: "Base price",
		pricelabs: "PriceLabs",
		partner: "Developer API"
	},
	conversionEvent: {
		SIGNUP: "Signup",
		FIRST_BOOKING: "First booking",
		REPEAT_BOOKING: "Repeat booking"
	},
	houseRuleAllowed: {
		self_checkin_lockbox: "Self check-in with lockbox",
		late_checkout_preapproved: "Late check-out only if pre-approved",
		pets_allowed: "Pets allowed",
		smoking_allowed: "Smoking allowed",
		parties_allowed: "Parties and events allowed",
		commercial_photography_allowed: "Commercial photography allowed",
		quiet_hours: "Quiet hours 10:00 PM – 8:00 AM",
		id_before_arrival: "Guests must send ID/passports 48 hours prior to arrival",
		families_only: "Families only",
		married_couples_only: "Married couples only",
		report_damages_immediately: "Report any damages or maintenance issues immediately",
		no_rearranging_furniture: "Do not move or rearrange furniture",
		married_egyptian_arab_couples_only: "Unmarried Egyptian and Arab couples not allowed",
		valid_id_at_checkin: "Guests must present a valid ID upon check-in",
		booker_must_check_in: "The guest checking in must be the same person who made the booking",
		registered_guests_only: "Only registered guests are allowed on the property",
		guests_liable_for_damages: "Guests are responsible for any damages during their stay",
		lost_key_replacement_fee: "Lost keys or access cards: replacement fee applies",
		late_checkout_extra_charges: "Unauthorized late check-out may result in extra charges",
		no_illegal_activities: "No illegal activities or substances allowed on the premises",
		gather_used_towels: "Gather used towels",
		turn_lights_off: "Turn lights off",
		return_keys: "Return keys",
		throw_trash_away: "Throw trash away",
		lock_up: "Lock up"
	},
	houseRuleDisallowed: {
		pets_allowed: "No pets",
		smoking_allowed: "No smoking",
		parties_allowed: "No parties or events",
		commercial_photography_allowed: "No commercial photography"
	},
	predefinedRoleName: {
		co_host: "Co-Host / Property Manager",
		reservations_agent: "Reservations Agent",
		guest_communications: "Guest Communications",
		finance_manager: "Finance Manager",
		revenue_manager: "Revenue Manager",
		read_only_analyst: "Read-only Analyst",
		listing_editor: "Listing Editor",
		housekeeping: "Housekeeping (arrivals only)",
		team_administrator: "Team Administrator",
		verification_compliance: "Verification / Compliance",
		front_desk: "Front Desk",
		housekeeping_operations: "Housekeeping (operations)"
	},
	predefinedRoleDescription: {
		co_host: "Runs the day-to-day: edits and publishes listings, manages the calendar, and handles every booking and guest message. No access to finance or the team.",
		reservations_agent: "Works the booking queue end to end — approve, reject, cancel, create — and talks to guests. Cannot change listings, prices or rules.",
		guest_communications: "Answers guest messages, with read-only context on the booking, the stay and the listing.",
		finance_manager: "Payouts, transactions, billing details and outstanding debt. Cannot change listings or the team.",
		revenue_manager: "Owns pricing rules, booking rules, coupons and availability. Reads bookings for context but moves no money.",
		read_only_analyst: "Sees everything and changes nothing — for a review, an audit or an advisor.",
		listing_editor: "Builds and publishes listings and travel guides. No bookings, calendar, messages or money.",
		housekeeping: "Sees who arrives when and where, and nothing else. Usually limited to specific properties.",
		team_administrator: "Invites and removes members and manages property assignments. Cannot change roles, listings or money.",
		verification_compliance: "Assembles and submits verification documents for the workspace and its properties.",
		front_desk: "Runs arrivals, departures and room assignment on shift: checks guests in and out, marks no-shows, inspects rooms and hands them to housekeeping. Talks to guests. Cannot change listings, prices or money.",
		housekeeping_operations: "Turns rooms over on shift: sees each room's status and marks it dirty or clean. No bookings, guest details or money."
	},
	houseRuleCategory: {
		checking_in_out: "Checking in and out",
		during_stay: "During your stay",
		additional: "Additional rules",
		before_you_go: "Before you go"
	},
	paymentGatewayOption: {
		paymob: "Egyptian card",
		stripe: "International card"
	},
	paymentGatewayOptionHint: {
		paymob: "Cards issued in Egypt, plus local wallets and instalments.",
		stripe: "Visa, Mastercard and American Express issued outside Egypt."
	},
	paymentGatewaySwitch: {
		paymob: "Paying with an Egyptian card? Switch to Egyptian checkout",
		stripe: "Paying with a card issued outside Egypt? Switch to international checkout"
	},
	routingOutcome: {
		ROUTED: "Routed",
		AMBIGUOUS: "Ambiguous",
		NO_SIGNAL: "No signal"
	},
	routingCertaintyBand: {
		NONE: "None",
		BELOW_THRESHOLD: "Below threshold",
		AT_THRESHOLD: "At threshold",
		CONFIDENT: "Confident"
	},
	inventoryKind: {
		unit: "Stay",
		service: "Service",
		experience: "Experience"
	},
	inventoryStatus: {
		draft: "Draft",
		active: "Published",
		paused: "Paused",
		archived: "Archived"
	},
	serviceSchedulingKind: {
		slot: "By session",
		range: "By day",
		add_on: "Add-on to a stay"
	},
	experienceCategory: {
		food: "Food & drink",
		outdoors: "Outdoors",
		culture: "Culture & history",
		wellness: "Wellness",
		nightlife: "Nightlife",
		water: "On the water",
		art: "Art & design",
		sports: "Sports",
		workshop: "Workshops",
		tour: "Tours"
	},
	serviceCategory: {
		cleaning: "Cleaning",
		photography: "Photography",
		chef: "Private chef",
		transport: "Transport",
		wellness: "Wellness",
		childcare: "Childcare",
		maintenance: "Maintenance",
		guide: "Guide",
		training: "Training",
		other: "Other"
	},
	slotStatus: {
		scheduled: "Scheduled",
		cancelled: "Cancelled"
	},
	imageOwnerKind: {
		property: "Property",
		experience: "Experience",
		service: "Service"
	},
	partnerWebhookEventType: {
		"endpoint.challenge": "Endpoint challenge",
		"booking.requested": "Booking requested",
		"booking.confirmed": "Booking confirmed",
		"booking.rejected": "Booking rejected",
		"booking.checked_in": "Guest checked in",
		"booking.checked_out": "Guest checked out",
		"booking.cancelled": "Booking cancelled",
		"booking.modified": "Booking modified",
		"review.created": "Review created",
		"listing.published": "Listing published",
		"listing.unlisted": "Listing unlisted",
		"pricing.mode_changed": "Pricing mode changed",
		"pricing.currency_changed": "Listing currency changed",
		"calendar.held": "Dates held",
		"calendar.released": "Held dates released"
	},
	partnerWebhookEventTypeDescription: {
		"endpoint.challenge": "Sent once, while you register: echo the challenge back to activate the endpoint.",
		"booking.requested": "A guest asked to book a listing that needs your answer.",
		"booking.confirmed": "A guest completed and paid for a booking.",
		"booking.rejected": "The request to book was declined.",
		"booking.checked_in": "The guest confirmed their arrival.",
		"booking.checked_out": "The guest confirmed their departure.",
		"booking.cancelled": "A booking was cancelled, by the guest or the host.",
		"booking.modified": "A change of dates or guests was applied to a booking.",
		"review.created": "A guest left a review on one of your listings.",
		"listing.published": "A listing became bookable.",
		"listing.unlisted": "A listing stopped being bookable.",
		"pricing.mode_changed": "Who sets a listing's nightly rates changed — the platform, you, or an external source.",
		"pricing.currency_changed": "A listing's pricing currency changed; rates in the old currency no longer apply.",
		"calendar.held": "A guest reached checkout and the nights are off sale while they pay.",
		"calendar.released": "A hold ended — the nights are free again, or a booking took them."
	},
	conversationStage: {
		inquiry: "Inquiry",
		requested: "Request pending",
		upcoming: "Upcoming",
		staying: "Staying now",
		past: "Past stay"
	},
	listingLifecycleState: {
		live: "Live",
		unpublished: "Unpublished",
		pending_review: "In review",
		rejected: "Not approved",
		suspended: "Suspended"
	},
	housekeepingStatus: {
		dirty: "Dirty",
		clean: "Clean",
		inspected: "Inspected"
	},
	housekeepingEventSource: {
		manual: "By a team member",
		checkout: "After check-out",
		vacant_sweep: "Empty for too long",
		out_of_order_ended: "Back in service"
	},
	roomOccupancy: {
		out_of_order: "Out of order",
		turnover: "Turnover",
		arriving: "Arriving",
		departing: "Departing",
		stay_over: "Stay-over",
		vacant: "Vacant"
	},
	reportKind: {
		occupancy: "Occupancy",
		"adr-revpar": "ADR & RevPAR",
		pace: "Pace",
		"booking-window": "Booking window",
		cancellations: "Cancellations"
	},
	reportMetric: {
		occupancy: "Occupancy",
		adr: "ADR",
		revpar: "RevPAR",
		room_revenue: "Room revenue",
		bookings: "Bookings",
		cancellation_rate: "Cancellation rate",
		available_room_nights: "Available room-nights",
		occupied_room_nights: "Occupied room-nights",
		room_nights_sold: "Room-nights sold",
		median_lead_days: "Median lead time"
	},
	reportGroupBy: {
		day: "Day",
		month: "Month",
		room_type: "Room type",
		rate_plan: "Rate plan"
	},
	bookingWindowBucket: {
		0: "Same day",
		"1-3": "1–3 days",
		"4-7": "4–7 days",
		"8-14": "8–14 days",
		"15-30": "15–30 days",
		"31-60": "31–60 days",
		"61+": "61+ days"
	},
	payoutAttachmentStatus: {
		pending: "Processing",
		ready: "Ready",
		failed: "Failed"
	},
	adminMcpKeyScope: {
		admin_insights_read: "Platform insights",
		admin_finance_read: "Finance",
		admin_ops_read: "Operations health"
	},
	adminMcpKeyScopeDescription: {
		admin_insights_read: "Bookings, accounts, workspaces, the KYC and listing-review queues, support and the developer platform — counts and pseudonymised rows, never contact details.",
		admin_finance_read: "The platform's money: balances, payouts, host debt, transactions, refunds, revenue and coupon cost — per currency, never bank or card details.",
		admin_ops_read: "Queue, cron, outbox and webhook-inbox health — counts and states, never message bodies."
	},
	adminMcpKeyStatus: {
		active: "Active",
		expired: "Expired",
		revoked: "Revoked"
	},
	hostResponseTimeBucket: {
		within_hour: "Typically responds within an hour",
		within_few_hours: "Typically responds within a few hours",
		within_day: "Typically responds within a day"
	},
	hostResponseTimeBucketSelf: {
		within_hour: "You typically respond within an hour",
		within_few_hours: "You typically respond within a few hours",
		within_day: "You typically respond within a day"
	}
};
//#endregion
export { e as default };
